"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _DrupalLivestreamNugget = _interopRequireDefault(require("./DrupalLivestreamNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../../helpers/CordovaFileHelper"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _StringHelper = _interopRequireDefault(require("../../../../helpers/StringHelper"));

var _WatchedSequences = _interopRequireDefault(require("./WatchedSequences"));

var _LivestreamNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/LivestreamNugget"));

var _DrupalVideoNuggetStrings = require("./DrupalVideoNuggetStrings");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _UrlHelper = _interopRequireDefault(require("../../../../helpers/UrlHelper"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _Video = _interopRequireDefault(require("../../Video/Video"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _VideoActionManager = _interopRequireWildcard(require("./VideoActionManager"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _PlayCircleFilled = _interopRequireDefault(require("@material-ui/icons/PlayCircleFilled"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _dompurify = _interopRequireDefault(require("dompurify"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FULLSCREEN_ENTER_ICON = require('./assets/fullscreen_enter.svg');

var DOM_PREFIX = 'livestreanContainer_';
var TRACK_KINDS = {
  CAPTIONS: 'captions'
};
/**
 * How often we should be checking for an update to the live status.
 * 10 seconds is generally a good frequency, it is not useful to check more often.
 */

var UPDATE_FREQUENCY = 10 * 1e3;
/**
 * The code of the error which the player may raise if the livestream goes offline or finishes.
 */

var LIVESTREAM_COMPLETE_ERROR = 230001;
/**
 * The code of the error emitted by JW Player's HLS implementation if buffering stalls.
 * This may happen when a livestream (suddenly) finishes and no more segments are available to buffer.
 * In this case we'll switch back to VOD playback.
 */

var HLS_BUFFER_STALL_WARNING = 334001;
/**
 * The maximum number of times we'll try before giving up configuring a player.
 * @type {number}
 */

var MAX_RETRIES = 3;

var DrupalLivestreamNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalLivestreamNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalLivestreamNugget);

  function DrupalLivestreamNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalLivestreamNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "fetchJSON", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, init) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(url, init).then(function (response) {
                  if (!response.ok) {
                    throw new Error("Unable to fetch ".concat(url, ": ").concat(response.statusText));
                  }

                  return response.json();
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getChannelStatus", function () {
      var nugget = _this.getNugget();

      if (nugget.channelId) {
        // returns something like:
        // {"status": "active", "current_event": "M540QtZw"}
        return _this.fetchJSON("https://cdn.jwplayer.com/live/channels/".concat(nugget.channelId, ".json"));
      }

      return null;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getPlaylist", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(eventId) {
        var url, response, image, m3u8Obj, sanitizedM3u8;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // return something like:
                // {"title":"ergotest 2021-06-03 at 13:26","description":"","kind":"Single Item","playlist":[
                // {"title":"ergotest 2021-06-03 at 13:26","mediaid":"M540QtZw","link":"https://cdn.jwplayer.com/previews/M540QtZw","image":"https://cdn.jwplayer.com/v2/media/M540QtZw/poster.jpg?width=720",
                // "images":[{"src":"https://cdn.jwplayer.com/v2/media/M540QtZw/poster.jpg?width=320","width":320,"type":"image/jpeg"},{"src":"https://cdn.jwplayer.com/v2/media/M540QtZw/poster.jpg?width=480","width":480,"type":"image/jpeg"},{"src":"https://cdn.jwplayer.com/v2/media/M540QtZw/poster.jpg?width=640","width":640,"type":"image/jpeg"},{"src":"https://cdn.jwplayer.com/v2/media/M540QtZw/poster.jpg?width=720","width":720,"type":"image/jpeg"}],"duration":0,"pubdate":1622726806,"description":"","sources":[{"file":"https://cdn.jwplayer.com/live/events/M540QtZw.m3u8","type":"application/vnd.apple.mpegurl"}],"variations":{},"livestream_channel_id":"kDCZT14Y"}],"feed_instance_id":"46ab51cc-855a-426b-9082-83759d99c8d9"}
                url = "https://cdn.jwplayer.com/v2/media/".concat(eventId);
                console.log('getPlayList', url);
                _context2.next = 4;
                return _this.fetchJSON(url, {
                  cache: "no-cache"
                });

              case 4:
                response = _context2.sent;
                console.log('getPlayList', response);

                if (response && response.playlist && response.playlist.length > 0 && response.playlist[0].sources && response.playlist[0].sources.length > 0) {
                  image = response.playlist[0].image;
                  if (image) _this.setState({
                    thumbnail: image
                  });
                  m3u8Obj = response.playlist[0].sources[0];
                  console.log('getPlayList m3u8Obj', m3u8Obj);

                  if (m3u8Obj && m3u8Obj.file) {
                    sanitizedM3u8 = _this._correctM3u8(_dompurify["default"].sanitize(m3u8Obj.file, {
                      ALLOW_UNKNOWN_PROTOCOLS: true
                    }));
                    console.log('getPlayList', sanitizedM3u8);

                    _this.setState({
                      noVideoAvailable: false,
                      availableMedia: sanitizedM3u8
                    });
                  }
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkChannelStatus", function () {
      if (!_this.intervalId) {
        console.log("Waiting for Live Channel to become active."); // Make sure to execute this method every UPDATE_FREQUENCY milliseconds.

        _this.intervalId = setInterval(_this.checkChannelStatus, UPDATE_FREQUENCY);
      }

      _this.getChannelStatus().then( /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(channelStatus) {
          var eventId;
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  console.log("Received channel status: %O", channelStatus);

                  if (!(channelStatus['status'] === 'active')) {
                    _context3.next = 10;
                    break;
                  }

                  // Determine the id of the active event based on the returned status.
                  eventId = channelStatus['current_event']; // Check if we have seen this eventId before.

                  if (!(_this.currentEventId === eventId)) {
                    _context3.next = 5;
                    break;
                  }

                  return _context3.abrupt("return");

                case 5:
                  console.log('checkChannelStatus active eventId', eventId);
                  _this.currentEventId = eventId; // Stop polling the channel status.

                  _this.intervalId = clearInterval(_this.intervalId);
                  _context3.next = 10;
                  return _this.getPlaylist(eventId);

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }(), function (error) {
        console.log("Unable to fetch the channel status: ".concat(error)); // If we fail to retrieve the channel status, then give up.

        _this.intervalId = clearInterval(_this.intervalId);
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          if (el.id === 'playBtn') {
            _this.setState({
              videoIsPlaying: true
            });
          }
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getNugget", function () {
      return _this.state.content[_this.props.id];
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onLowPowerModeEnabled", function () {
      _this.lowPowerModeTimeoutHandle = setTimeout(function () {
        (0, _MuiAlertHelper.showAlertWithOptions)({
          message: (0, _DrupalVideoNuggetStrings.getString)('POWER_MODE_ENABLED'),
          title: (0, _DrupalVideoNuggetStrings.getString)('WATCH_OUT'),
          size: 'large',
          showCloseButton: true
        });

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.LOW_POWER_MODE_ALERT_TIMESTAMP, (0, _now["default"])(), false);
      }, 1000);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onError", function (error) {
      console.log({
        videoError: error
      });

      if (_this.state.playsM3u8 && _this.state.sanitizedSrc) {
        _this.setState({
          playsM3u8: false
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onMetadataLoaded", function () {
      if (_this.errorTimeout) _this.errorTimeout.invalidate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onPlay", function () {
      if (!_this.props.inSwipeContainer) {
        _this.props.markAsRead(_this.props.id);
      }

      _this.setState({
        isPlaying: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onPause", function () {
      _this.setState({
        isPlaying: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setIsOffline", function () {
      _this.setState({
        isOnline: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setIsOnline", function () {
      _this.setState({
        isOnline: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "toggleFullscreen", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var onFullscreenLeave;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this.videoElement) {
                _context4.next = 3;
                break;
              }

              console.warn('not toggling fullscreen because video element is null');
              return _context4.abrupt("return");

            case 3:
              if (!_this.videoElement.requestFullscreen()) {
                _context4.next = 12;
                break;
              }

              _this.setState({
                fullscreen: true
              });

              _this.videoElement.requestFullscreen();

              if (!window.screen.orientation) {
                _context4.next = 9;
                break;
              }

              _context4.next = 9;
              return window.screen.orientation.lock('landscape');

            case 9:
              onFullscreenLeave = function onFullscreenLeave() {
                if (document.fullscreenEnabled || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen) {
                  _this.videoElement.onfullscreenchange = null;

                  _this.setState({
                    fullscreen: false
                  });

                  if (window.screen.orientation) {
                    if (_config["default"].onlyPortrait) {
                      window.screen.orientation.lock('portrait');
                    } else {
                      window.screen.orientation.unlock();
                    }
                  }
                }
              };

              setTimeout(function () {
                _this.videoElement.onfullscreenchange = onFullscreenLeave;
              }, 500);
              setTimeout(function () {
                return onFullscreenLeave;
              }, 3000);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    _this.state = _objectSpread({
      // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor
      waitingForActivation: false,
      fullscreen: false,
      videoIsPlaying: false,
      sanitizedSrc: null,
      thumbnail: null,
      noVideoAvailable: true
    }, _this.state);
    _this.videoElement = null;
    _this.domId = _StringHelper["default"].createShortId();
    _this.watchedSequences = null; // will be set after mount

    _this.videoActionManager = null;
    _this.errorTimeout = null;
    _this.active = true;
    _this.intervalId = null;
    _this.currentEventId = null;

    _this.props.registerNugget(_this.props.id, _LivestreamNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalLivestreamNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.LOW_POWER_MODE_ALERT_TIMESTAMP]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalLivestreamNugget, [{
    key: "_setSequenceWatcher",
    value: function _setSequenceWatcher() {
      if (!this.videoElement) {
        this.videoElement = document.getElementById(this.domId);

        if (this.videoElement && this.props.action) {
          this.videoActionManager = new _VideoActionManager["default"](this.videoElement);
          this.executeAction();
        }
      }

      if (this.videoElement) {
        if (!this.watchedSequences) {
          this.watchedSequences = new _WatchedSequences["default"](this.getNugget(), this.videoElement);
          this.videoElement.addEventListener('play', this.onPlay);
          this.videoElement.addEventListener('pause', this.onPause);
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.registerNuggetPosition(this.props.id, _LivestreamNugget["default"].CLASS, this.getDomId());
      var nugget = this.getNugget();
      this.shortFilename = "".concat(nugget.id).concat(_CordovaFileHelper.FILE_POSTFIXES.VIDEO_MP4);
      this.checkChannelStatus();

      this._setSequenceWatcher();

      this.initListeners();

      if (this.props.inGalleryContainer && this.props.galleryContainerIndex === 0 || !this.props.inGalleryContainer) {
        this.showLowPowerModeAlertIfNeeded();
      }

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }
    }
    /**
     * Utility function to fetch a JSON document.
     * @param url
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLivestreamNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }

      this._setSequenceWatcher();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLivestreamNugget.prototype), "componentWillUnmount", this).call(this);
      this.removeListeners();

      if (this.videoActionManager) {
        this.videoActionManager.cleanUp();
      }

      if (this.lowPowerModeTimeoutHandle) {
        clearTimeout(this.lowPowerModeTimeoutHandle);
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "showLowPowerModeAlertIfNeeded",
    value: function showLowPowerModeAlertIfNeeded() {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        return;
      }

      var lastTimestmap = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LOW_POWER_MODE_ALERT_TIMESTAMP);

      var newTimeStamp = (0, _now["default"])();
      var interval = 30000;

      if (lastTimestmap) {
        if (newTimeStamp - interval > lastTimestmap) {
          console.log('SHOWING ALERT because 30 secs have passed');

          if (window.cordova && window.cordova.plugins && window.cordova.plugins.equeoCheckLowPowerMode) {
            window.cordova.plugins.equeoCheckLowPowerMode.check(this.onLowPowerModeEnabled);
          }
        }
      } else {
        console.log('SHOWING ALERT because it hasnt been shown yet');

        if (window.cordova && window.cordova.plugins && window.cordova.plugins.equeoCheckLowPowerMode) {
          window.cordova.plugins.equeoCheckLowPowerMode.check(this.onLowPowerModeEnabled);
        }
      }
    }
  }, {
    key: "_correctProtocol",
    value: function _correctProtocol(url) {
      var protocol = window.location.protocol.toLowerCase();

      if (protocol === 'file:' || protocol === 'https:' || protocol === 'http:') {
        var parts = _UrlHelper["default"].parseURL(url);

        var protocolToUse = protocol === 'file:' ? 'https:' : protocol;
        var host = protocol === 'https:' && parts.host.match(/:80$/) ? parts.host.substring(0, parts.host.length - 3) : protocol === 'http:' && parts.host.match(/:443$/) ? parts.host.substring(0, parts.host.length - 4) : parts.host;
        return protocolToUse + '//' + host + (parts.pathname.substring(0, 1) !== '/' ? '/' : '') + parts.pathname + parts.search + parts.hash;
      }

      return url;
    }
  }, {
    key: "_correctM3u8",
    value: function _correctM3u8(url) {
      if (url.match('cdn.equeo.de')) {
        url = url.replace(/cdn.equeo.de/, 'content.jwplatform.com');
      }

      return this._correctProtocol(url);
    }
  }, {
    key: "_correctThumbnail",
    value: function _correctThumbnail(url) {
      if (url.match('cdn.equeo.de')) {
        url = url.replace(/cdn.equeo.de/, 'assets-jpcust.jwpsrv.com');
      }

      return this._correctProtocol(url);
    } //   getCorrectVideoUrl = async (m3u8) => {
    //     try {
    //       console.log('getCorrectVideoUrl', m3u8)
    //       const parts = UrlHelper.parseURL(m3u8)
    //       const filename = parts.pathname.split('/').pop()
    //       const mediaId = filename.substring(0, filename.indexOf('.'))
    //       const infoUrl = parts.protocol + '//cdn.jwplayer.com/v2/media/' + mediaId
    //       const videoRequestResult = await httpGetExtern(infoUrl, {}, null, null, null, null)
    //
    //       console.log('videoRequestResult', videoRequestResult)
    //
    //       if (videoRequestResult.status === 200 && videoRequestResult.data) {
    //         if (this.errorTimeout) this.errorTimeout.invalidate()
    //         const sources = videoRequestResult.data.playlist[0].sources
    //         const tracks = videoRequestResult.data.playlist[0].tracks || []
    //
    //         tracks.forEach(track => {
    //           console.log('track', track)
    //           if (track && track.kind && track.kind === TRACK_KINDS.CAPTIONS) {
    //             this.setState({subtitleUrl: track.file})
    //           }
    //         })
    //
    //         let optimalLongSide = null
    //         let longSideDiff = null
    //         let optimalMp4File = null
    //
    // //        const width = Math.max(window.screen.height, window.screen.width) || 640
    //         const width = Math.max(window.innerHeight, window.innerWidth) || 640
    //         // const width = this.videoElement && this.videoElement.offsetWidth > 0 ? this.videoElement.offsetWidth : 640
    //         for (let i = 0, l = sources.length; i < l; i++) {
    //           const description = sources[i]
    //           if (description.label === 'Passthrough') continue
    //           if (!description.hasOwnProperty('width')) continue
    //           if (!optimalLongSide || Math.abs(width - description.width) < longSideDiff) {
    //             optimalMp4File = description.file
    //             optimalLongSide = description.width
    //             longSideDiff = Math.abs(width - optimalLongSide)
    //           }
    //         }
    //
    //         console.log('optimalMp4File', optimalMp4File)
    //
    //         if (optimalMp4File) {
    //           // follow any redirects and set that url then
    //           // optimalMp4File = await DownloadHelper.getRedirectedUrl(optimalMp4File)
    //
    //           // const parts = downloadableSrc.split('?')
    //           // downloadableSrc = 'http://192.168.178.106:8080/headers?' + parts[1]
    //
    //           // set actualized mp4 file
    //           console.log('DrupalVideoNugget.getCorrectVideoUrl set: ', optimalMp4File)
    //           this.setState({ sanitizedSrc: optimalMp4File, playsM3u8: false })
    //         }
    //       }
    //       else {
    //         console.log('ERROR', 'DrupalVideoNugget.getCorrectVideoUrl', 'status != 200', videoRequestResult)
    //       }
    //     }
    //     catch (error) {
    //       console.log('ERROR', 'Drupal.VideoNugget.getCorrectVideoUrl', error)
    //     }
    //   }

  }, {
    key: "initListeners",
    value: function initListeners() {
      _DeviceInfoHelper["default"].addOfflineListener(this.setIsOffline);

      _DeviceInfoHelper["default"].addOnlineListener(this.setIsOnline);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      document.removeEventListener('offline', this.setIsOffline);
      document.removeEventListener('online', this.setIsOnline);

      if (this.videoElement) {
        this.videoElement.removeEventListener('play', this.onPlay);
        this.videoElement.removeEventListener('pause', this.onPause);
        this.videoElement.removeEventListener('canplaythrough', this.videoElement.play);
      }

      if (this.watchedSequences) this.watchedSequences.postAndUnload();
    }
  }, {
    key: "renderFullscreenButton",
    value: function renderFullscreenButton() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          backgroundColor: this.props.forcedUIColor
        } : {
          backgroundColor: _cssConstants["default"].colors.buttonBackground
        },
        className: "".concat(this.props.inGalleryContainer ? _DrupalLivestreamNugget["default"].fullscreenButtonSmall : _DrupalLivestreamNugget["default"].fullscreenButton),
        onClick: this.toggleFullscreen
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: _DrupalLivestreamNugget["default"].icon,
        src: FULLSCREEN_ENTER_ICON
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var nugget = this.getNugget();
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var src;

      if (this.state.availableMedia) {
        src = this.state.availableMedia;
        console.log('src is m3u8', src);
      }

      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var posterPath = null;

      if (this.state.thumbnail) {
        posterPath = this._correctThumbnail(this.state.thumbnail);
      }

      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var buttonColor;

      if (_config["default"].isErgoApp) {
        buttonColor = _cssConstants["default"].colors.ergoRed;
      } else if (_config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor) {
        buttonColor = this.props.forcedUIColor;
      } else {
        buttonColor = _cssConstants["default"].colors.buttonBackground;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "videoContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "LivestreamNugget_".concat(this.props.id, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(nugget.theme, " videodiv ").concat(_DrupalLivestreamNugget["default"].videodiv, " ").concat(nugget.title && nugget.show_title ? '' : 'extraPadding')
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'titleSmall'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DeviceInfoHelper["default"].isAndroid() ? _DrupalLivestreamNugget["default"].titleSmall : ''
      }, nugget.title), _DeviceInfoHelper["default"].isAndroid() ? this.renderFullscreenButton() : null) : nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'title'
      }, nugget.title, _DeviceInfoHelper["default"].isAndroid() ? this.renderFullscreenButton() : null) : null, this.state.noVideoAvailable ? /*#__PURE__*/_react["default"].createElement("div", null, "Zur Zeit findet kein Liveevent statt. Bitte schauen Sie sp\xE4ter noch einmal rein") : this.state.videoIsPlaying && src ? /*#__PURE__*/_react["default"].createElement(_Video["default"], {
        autoPlay: true,
        controls: true,
        controlsList: 'nodownload',
        videoId: this.domId,
        src: src + '?playsinline=1',
        onLoadedMetadata: this.onMetadataLoaded,
        poster: posterPath,
        preload: 'none',
        playsInline: this.props.inGalleryContainer,
        subtitles: this.state.subtitleUrl,
        tabIndex: 0
      }) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], {
        tabIndex: 0,
        id: 'playBtn',
        className: 'doNotInvert',
        onClick: function onClick() {
          _this4.setState({
            videoIsPlaying: true
          });
        },
        style: {
          color: buttonColor,
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: '50%',
          height: '50%',
          transform: 'translate(-50%, -50%)'
        }
      }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "Posterbild des Videos",
        src: posterPath,
        onClick: function onClick() {
          _this4.setState({
            videoIsPlaying: true
          });
        }
      })), nugget.info ? /*#__PURE__*/_react["default"].createElement("p", {
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }) : null)), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this4.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this4.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalLivestreamNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalLivestreamNugget;
DrupalLivestreamNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  showControls: _propTypes["default"].bool,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  galleryContainerIndex: _propTypes["default"].number,
  setLike: _propTypes["default"].func
};
DrupalLivestreamNugget.defaultProps = {
  id: null,
  showControls: true,
  galleryContainerIndex: 100
};